import React from 'react';

import ProductEditForm from '@components/shared/products/ProductEdit';
import { useAdminProductService } from '@hooks/admin/products/useAdminProductService';

const AdminProductNew: React.FC = () => {
  return (
    <ProductEditForm
      useProductService={useAdminProductService}
    />
  );
};

export default AdminProductNew;
